import React from 'react';
import './App.css';
import Navbar from './project/Navbar';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './project/Home';
import Intro from './project/about/Intro';
import Exhibitions from './project/about/Exhibitions';
import Biography from './project/about/Biography';
import Teaching from './project/about/Teaching';
import Gallery from './project/Gallery';
import Contact from './project/Contact';



// admin
import ProtectedRoute from './admin_panel/ProtectedRoute';
import Signin from './admin_panel/Signin';
import AdminHome from './admin_panel/AdminHome';
import AdminGallery from './admin_panel/AdminGallery';
import AdminMessages from './admin_panel/AdminMessages';
import AdminAddImage from './admin_panel/AdminAddImage';
import AdminSettings from './admin_panel/AdminSettings';
import AdminSlider from './admin_panel/AdminSlider';
import AdminPhotoGallery from './admin_panel/AdminPhotoGallery';
import AdminUpdates from './admin_panel/AdminUpdates';
import AdminCollections from './admin_panel/AdminCollections';


// admin

function App() {
  const location = useLocation();

  // agar path /admin hai to Navbar hide hoga
  const hideNavbar = location.pathname.includes("admin");

  return (
    <>
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path='/' element={<Home />} />

        {/* About Dropdown Pages */}
        <Route path='/about/intro' element={<Intro />} />
        <Route path='/about/exhibitions' element={<Exhibitions />} />
        <Route path='/about/achievements' element={<Biography />} />
        <Route path='/about/teaching' element={<Teaching />} />

        {/* Gallery dynamic route */}
        <Route path='/:category/:subcat' element={<Gallery />} />

        {/* Contact page */}
        <Route path='/contact' element={<Contact />} />

        {/* Admin page */}
        <Route path='/admin' element={<Signin />} />

        {/* Protected admin routes */}
        <Route element={<ProtectedRoute />}>
          <Route path='/admin/dashboard' element={<AdminHome />} />
          <Route path='/admin/admingallery' element={<AdminGallery />} />
          <Route path='/admin/adminmessages' element={<AdminMessages />} />
          <Route path='/admin/adminaddimage' element={<AdminAddImage />} />
          <Route path='/admin/adminsettings' element={<AdminSettings />} />
          <Route path='/admin/adminslider' element={<AdminSlider />} />
          <Route path='/admin/adminphotogallery' element={<AdminPhotoGallery />} />
          <Route path='/admin/adminupdates' element={<AdminUpdates />} />
          <Route path='/admin/admincollections' element={<AdminCollections />} />
        </Route>


      </Routes>
    </>
  );
}

export default App;
